import BreadCrumbs from 'components/global/BreadCrumbs'
import React, { useState } from 'react'
import ManageButtonLeague from './ManageButton'
import './styles/infoheader.scss'
import eventTime from 'assets/Images/time-event.svg'
import eventLocation from 'assets/Images/location-event.svg'
import dummy from 'assets/Images/No-image-found.jpeg'
import { CalendarBlank, NavigationArrow } from '@phosphor-icons/react'
import { leagueEventStore } from 'state/league/leagueEvent'
import { LeagueFinalResp } from 'types/league/league'
import { convertMinutesToLocalTime, convertToLocal } from 'helper/utility'
import { infoMessage } from 'api/global'
import ScheduleModal from '../Common/Modals/ScheduleModal'
import { leagueGamesStore } from 'state/league/leageGames'
import { leaguePracticeStore } from 'state/league/leaguePractice'
import AddGameModal from './Tabs/Modals/Schedule/AddGameModal'
import AddPracticeModal from './Tabs/Modals/Schedule/AddPracticeModal'
import SelectGame from './Modals/SelectGame'
import EnterScore from './Modals/EnterScore'
import SelectGameForLog from './Modals/SelectGameForLog'
import EnterLog from './Modals/EnterLog'
import LiveLog from './Modals/LiveLog'
import ManagePlayersModal from './Modals/ManagePlayersModal'
import EditTimeModal from './Tabs/Modals/Schedule/EditTimeModal'
import EditFieldModal from './Tabs/Modals/Schedule/EditFieldModal'
import AddUpdateModal from './Tabs/Modals/Updates/AddUpdateModal'
import { useParams } from 'react-router-dom'
import { manageTeamStore } from 'state/league/manageTeam'
import { leagueUpdatesStore } from 'state/league/leagueUpdates'

const InfoHeader: React.FC = () => {
  const { id: commonLeagueId }: { id: string } = useParams()
  const {
    addGameModal,
    selectGameModal,
    addScoreModal,
    editTimeModal,
    editFieldModal,
    selectGameForLogModal,
    enterLogModal,
    liveLogModal,
  } = leagueGamesStore(store => ({
    addGameModal: store.addGameModal,
    selectGameModal: store.selectGameModal,
    addScoreModal: store.addScoreModal,
    editTimeModal: store.editTimeModal,
    editFieldModal: store.editFieldModal,
    selectGameForLogModal: store.selectGameForLogModal,
    enterLogModal: store.enterLogModal,
    liveLogModal: store.liveLogModal,
  }))
  const { addPracticeModal } = leaguePracticeStore(store => ({
    addPracticeModal: store.addPracticeModal,
  }))
  const { managePlayersModal } = manageTeamStore(state => ({
    managePlayersModal: state.managePlayersModal,
  }))
  const { addUpdateModal, editUpdateModal } = leagueUpdatesStore(store => ({
    addUpdateModal: store.addUpdateModal,
    editUpdateModal: store.editUpdateModal,
  }))
  const [openScheduleModal, setOpenScheduleModal] = useState(false)
  const { leagueData }: { leagueData: LeagueFinalResp } = leagueEventStore(
    store => ({
      leagueData: store.leagueData,
    }),
  )

  return (
    <>
      <div className="flex justify-between align-center mt-20px">
        <BreadCrumbs
          links={[
            {
              name: 'Events',
              link: '/spaces?page=1&limit=10',
            },
            {
              name: leagueData.name,
              link: `/spaces/update-league/${leagueData._id}`,
            },
          ]}
        />
        <ManageButtonLeague id={commonLeagueId} />
      </div>
      <div className="info_header_container">
        <div className="leage_image">
          <img
            src={leagueData?.coverPhotos?.[0]?.post || dummy}
            alt="league"
          />
        </div>
        <div className="league_info">
          <h3 className="text-28 w-600">{leagueData.name}</h3>
          <div className="league_time_loc">
            <div className="icon_img_container">
              <img src={eventTime} alt="time" className="w-25px" />
              <div className="info">
                <h4>Time</h4>
                <p>{`Start on ${convertToLocal(
                  leagueData.startDate,
                  'MMM DD, YYYY',
                )} ${leagueData?.timings?.startTime ? convertMinutesToLocalTime(
                  leagueData.timings.startTime,
                ) : 'N/A'} - ${leagueData?.timings?.endTime ? convertMinutesToLocalTime(
                  leagueData.timings.endTime,
                ) : 'N/A'}`}</p>
                <button onClick={() => setOpenScheduleModal(true)}>
                  <CalendarBlank size={20} color="#2BA7CA" />
                  View Schedule
                </button>
              </div>
            </div>
            <div className="icon_img_container">
              <img src={eventLocation} alt="time" className="w-25px" />
              <div className="info">
                <h4>Location</h4>
                <p>{leagueData.location ? `${leagueData.location.street || 'N/A'}, ${leagueData.location.city || 'N/A'}, ${leagueData.location.state || 'N/A'}` : 'Location not available'}</p>
                <a
                  href={leagueData.location ? `https://www.google.com/maps/dir/${leagueData.location.city}/${leagueData.location.street}, ${leagueData.location.city}, ${leagueData.location.country}` : '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full"
                >
                  <button>
                    <NavigationArrow size={20} color="#2BA7CA" />
                    Get directions
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openScheduleModal && (
        <ScheduleModal
          openModal={openScheduleModal}
          setOpenModal={setOpenScheduleModal}
          datesOfEvent={leagueData.datesOfEvent}
          timings={leagueData.timings}
        />
      )}
      {addGameModal && <AddGameModal />}
      {addPracticeModal && <AddPracticeModal />}
      {selectGameModal && <SelectGame />}
      {addScoreModal && <EnterScore />}
      {selectGameForLogModal && <SelectGameForLog />}
      {enterLogModal && <EnterLog />}
      {liveLogModal && <LiveLog />}
      {managePlayersModal && <ManagePlayersModal />}
      {editTimeModal && <EditTimeModal />}
      {editFieldModal && <EditFieldModal />}
      {(addUpdateModal || editUpdateModal) && <AddUpdateModal />}
    </>
  )
}

export default InfoHeader
